// /home/szymon/kreator2/frontend/src/hooks/useLocalHistory.js
import { useState } from "react";

export function useLocalHistory() {
  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);

  function pushToHistory(oldValue) {
    setUndoStack((prev) => [...prev, oldValue]);
    setRedoStack([]); 
  }

  function localUndo() {
    if (undoStack.length === 0) return null;
    const last = undoStack[undoStack.length - 1];
    setUndoStack((prev) => prev.slice(0, prev.length - 1));
    setRedoStack((prev) => [...prev, last]);
    return last;
  }

  function localRedo() {
    if (redoStack.length === 0) return null;
    const last = redoStack[redoStack.length - 1];
    setRedoStack((prev) => prev.slice(0, prev.length - 1));
    setUndoStack((prev) => [...prev, last]);
    return last;
  }

  const canLocalUndo = undoStack.length > 0;
  const canLocalRedo = redoStack.length > 0;

  return {
    pushToHistory,
    localUndo,
    localRedo,
    canLocalUndo,
    canLocalRedo
  };
}
